module.exports = __webpack_public_path__ + "img/AliExpress.a43cd877.jpg";